import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 2em 0;

    .headline {
        font-size: 1.1em;
        margin: 0 0.7em;
        font-weight: 700;
    }

    .list {
        padding-top: 1.5em;
        margin: 0 0.4em;

        .list-element {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .icon {
                max-width: 100%;
                margin-right: 1em;
            }
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
        .list {
            padding: 0 0.5em;
            .list-element {
                .element-content {
                    width: 80%;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        .list {
            flex-flow: column nowrap;

            .list-element {
                width: 100%;

                .element-content {
                    width: 100%;
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        font-size: 120%;
    }
`;